class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  
  init() {
    // Add event listeners to all plus buttons
    this.addEventListener('click', this.handleAddToCart.bind(this));
  }
  
  handleAddToCart(event) {
    const button = event.target.closest('.cart-upsell__button');
    if (!button) return;
    
    event.preventDefault();
    
    const productItem = button.closest('.cart-upsell__item');
    const variantId = productItem.dataset.variantId;
    
    if (!variantId) {
      console.error('No variant ID found for upsell product');
      return;
    }

    this.addToCart(variantId, button);
  }
  
  async addToCart(variantId, button) {
    // Show loading state
    this.setButtonLoading(button, true);

    try {
      // Create form data
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      // Add sections for cart drawer update
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const sectionsToRender = cartDrawer.getSectionsToRender();
        formData.append('sections', sectionsToRender.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      // Use the same config as product-form.js
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData
      };
      
      // Delete Content-Type header like product-form.js does
      delete config.headers['Content-Type'];

      const response = await fetch(window.routes.cart_add_url, config);
      const data = await response.json();
      
      if (data.status) {
        // Handle error
        console.error('Error adding upsell product to cart:', data.description);
        this.showError(button, data.description);
      } else {
        // Success - update cart drawer
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
          setTimeout(() => {
            initUpsellSlider();
          }, 100);
        }
        
        // Show success feedback
        this.showSuccess(button);
      }
    } catch (error) {
      console.error('Error adding upsell product to cart:', error);
      this.showError(button, 'Something went wrong. Please try again.');
    } finally {
      this.setButtonLoading(button, false);
    }
  }
  
  setButtonLoading(button, isLoading) {
    const icon = button.querySelector('svg');
    if (isLoading) {
      button.disabled = true;
      button.classList.add('loading');
      
      // Store original content for restoration
      if (!button.dataset.originalContent) {
        button.dataset.originalContent = button.innerHTML;
      }
      
      // Show loading spinner
      button.innerHTML = `
        Add To Cart
        <span class="loading-spinner">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
            </circle>
          </svg>
        </span>
      `;
    } else {
      button.disabled = false;
      button.classList.remove('loading');
      
      // Restore original content
      if (button.dataset.originalContent) {
        button.innerHTML = button.dataset.originalContent;
      } else {
        button.innerHTML = icon ? icon.outerHTML : '<svg>...</svg>';
      }
    }
  }
  
  showSuccess(button) {
    // Store current content before showing success
    const currentContent = button.innerHTML;
    
    button.innerHTML = '✓';
    button.classList.add('success');
    
    setTimeout(() => {
      // Restore original content
      if (button.dataset.originalContent) {
        button.innerHTML = button.dataset.originalContent;
      } else {
        button.innerHTML = currentContent;
      }
      button.classList.remove('success');
    }, 1500);
  }
  
  showError(button, message) {
    // Store current content before showing error
    const currentContent = button.innerHTML;
    
    button.innerHTML = '!';
    button.classList.add('error');
    button.title = message;
    
    setTimeout(() => {
      // Restore original content
      if (button.dataset.originalContent) {
        button.innerHTML = button.dataset.originalContent;
      } else {
        button.innerHTML = currentContent;
      }
      button.classList.remove('error');
      button.removeAttribute('title');
    }, 2000);
  }
} 

customElements.define('cart-upsell', CartUpsell);

// Global function for initializing Swiper slider
function initUpsellSlider() {
  let upsellSliderSelector = '.cart-upsell__slider';
  let upsellSliderElement = document.querySelector(upsellSliderSelector);
  let upsellSlider = null;

  // Destroy existing Swiper instance if it exists
  if (window.upsellSliderInstance) {
    window.upsellSliderInstance.destroy(true, true);
    window.upsellSliderInstance = null;
  }

  if (upsellSliderElement) {
    const slidesCount = upsellSliderElement.querySelectorAll('.cart-upsell__item').length;
    upsellSlider = new Swiper(upsellSliderElement, {
      slidesPerView: slidesCount > 1 ? 1.3 : 1,
      spaceBetween: 8,
      grabCursor: true,
      keyboard: {
        enabled: true
      }
    });
    
    // Store the instance globally for cleanup
    window.upsellSliderInstance = upsellSlider;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initUpsellSlider();

  document.addEventListener("shopify:section:load", initUpsellSlider);
});

// Listen for cart update events using pub/sub system
let cartUpdateUnsubscriber = subscribe('cart-update', () => {
  setTimeout(() => {
    initUpsellSlider();
  }, 100);
});

// Clean up subscription when page unloads
window.addEventListener('beforeunload', () => {
  if (cartUpdateUnsubscriber) {
    cartUpdateUnsubscriber();
  }
});